import { render, staticRenderFns } from "./stocklar.vue?vue&type=template&id=1bef6bd0&"
import script from "./stocklar.vue?vue&type=script&lang=js&"
export * from "./stocklar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports